import { defineMessages } from 'react-intl'

export default defineMessages({
  title: { defaultMessage: 'Weekly Stats' },
  pageViews: { defaultMessage: 'Page Views' },
  receivedBobas: { defaultMessage: 'Received Bobas' },
})
